import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02217e87"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "blog-header fs-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-overlay" }, null, -1))
const _hoisted_3 = { class: "title d-flex align-items-center justify-content-center w-100 h-100" }
const _hoisted_4 = { class: "fs-1 px-3 text-center" }
const _hoisted_5 = { class: "select-indicators d-flex justify-content-center w-100" }

import { ref } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BlogSelect',
  props: {
    title: {}
  },
  emits: ['blog-switch'],
  setup(__props: any, { emit: emits }) {

  

  const toggleBlog = ref('1')
  

  function blogSwitchOne() {
    toggleBlog.value = '1'
    emits('blog-switch', '1')
  }
  function blogSwitchTwo() {
    toggleBlog.value = '2'
    emits('blog-switch', '2')
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(toggleBlog.value === '1' ? 'header-image' : 'header-image d-none'),
      style: {"background-image":"url('https://images.unsplash.com/photo-1487017159836-4e23ece2e4cf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1171&q=80')"}
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(toggleBlog.value === '2' ? 'header-image' : 'header-image d-none'),
      style: {"background-image":"url('https://images.unsplash.com/photo-1533136036465-1861830963f6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80')"}
    }, null, 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        onClick: blogSwitchOne,
        class: _normalizeClass(
          toggleBlog.value === '1'
            ? 'indicator selected-indicator mx-1'
            : 'indicator mx-1'
        )
      }, null, 2),
      _createElementVNode("div", {
        onClick: blogSwitchTwo,
        class: _normalizeClass(
          toggleBlog.value === '2'
            ? 'indicator selected-indicator mx-1'
            : 'indicator mx-1'
        )
      }, null, 2)
    ])
  ]))
}
}

})